<div class="modal-header" (click)="onClose()">
    <img class="close-icon" src="assets/icon/x.svg" alt="x">
</div>

<div class="modal-video-body">
    <div class="ratio ratio-16x9">

        @if(isFrame) {
            <iframe class="embed-responsive-item" [src]="videoUrl" id="videoOne" allowscriptaccess="always"
            allow="autoplay"></iframe>
        } @else {
            <video 
            controls 
            preload="auto"
            [src]="videoUrl"
            playsinline
            id="videoPlayer">
            Your browser does not support the video tag.</video>
        }

    </div>
</div>